import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjDetails"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.0006 4.0625C6.0233 4.0625 2.60298 6.51689 1.25 10C2.60298 13.4831 6.02328 15.9375 10.0006 15.9375C13.9779 15.9375 17.3994 13.4831 18.7511 10C17.3994 6.51687 13.9779 4.0625 10.0006 4.0625M10.0005 13.958C7.77359 13.958 6.02325 12.2172 6.02325 9.99999C6.02325 7.78276 7.77359 6.042 10.0005 6.042C12.2287 6.042 13.9779 7.78276 13.9779 9.99999C13.9779 12.2172 12.2287 13.958 10.0005 13.958M10.0006 7.62504C8.64878 7.62504 7.61398 8.65479 7.61398 10C7.61398 11.3453 8.64878 12.375 10.0006 12.375C11.3535 12.375 12.3872 11.3453 12.3872 10C12.3872 8.65479 11.3535 7.62504 10.0006 7.62504",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var SJ_details = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_details as default };
